import { render } from "./DcStatistics.vue?vue&type=template&id=a7be5cbe&scoped=true&ts=true"
import script from "./DcStatistics.vue?vue&type=script&lang=ts"
export * from "./DcStatistics.vue?vue&type=script&lang=ts"

import "./DcStatistics.vue?vue&type=style&index=0&id=a7be5cbe&scoped=true&lang=css"
import "./DcStatistics.vue?vue&type=style&index=1&id=a7be5cbe&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7be5cbe"]])

export default __exports__